export * from './EmailOverlay';
export * from './EmailOverlayBloc';

import { openModal } from '@core/components/ModalStack';
import { EmailOverlayProps } from './EmailOverlay';

export async function openEmailOverlay(props: EmailOverlayProps) {
  const { EmailOverlay } = await import('./EmailOverlay');

  openModal(EmailOverlay, props);
}
